/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface BatchUploadStartResponse
 */
export interface BatchUploadStartResponse {
  /**
   *
   * @type {string}
   * @memberof BatchUploadStartResponse
   */
  taskId: string;
}

/**
 * Check if a given object implements the BatchUploadStartResponse interface.
 */
export function instanceOfBatchUploadStartResponse(value: object): value is BatchUploadStartResponse {
  if (!('taskId' in value) || value['taskId'] === undefined) return false;
  return true;
}

export function BatchUploadStartResponseFromJSON(json: any): BatchUploadStartResponse {
  return BatchUploadStartResponseFromJSONTyped(json, false);
}

export function BatchUploadStartResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BatchUploadStartResponse {
  if (json == null) {
    return json;
  }
  return {
    taskId: json['task_id'],
  };
}

export function BatchUploadStartResponseToJSON(value?: BatchUploadStartResponse | null): any {
  if (value == null) {
    return value;
  }
  return {
    task_id: value['taskId'],
  };
}
